//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Autocomplete from 'vue2-autocomplete-js';
import UMUM from  '../../library/umum.js'
import FETCHING from  '../../library/fetching'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';
import MASTER_MENU from  '../../library/master_menu'

export default {
    components: {
        Autocomplete, 
    },          

    data () {
        return {
            FETCHING:FETCHING,
            token : localStorage.token,
            MASTER_MENU:MASTER_MENU, 
            index_ke: null,
            shape: '', 
            current: 3, 

            modal_edit_anggota_keluarga:false,
            terbitkanSurat  :false,

            modal_y:false,
            modal_n:false,

            lihat_blue:false,
            lihat_red:false,

            filterby:null,
            options_filterby :[{status:'-', nilai:null}, {status:'Diterima', nilai:true}, {status:'Ditolak', nilai:false}],
            option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],

            list_data:[],
            list_data_kecamatan:[],
            list_data_kabupaten:[],

            list_keluarga:null,

            page_limit : 10,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,
            UMUM : UMUM,

            options: [],
            // data_provinsi_opt: data_provinsi,
            // data_kabupaten_opt: data_kabupaten,
            // data_kecamatan_opt: data_kecamatan,
            // data_desa_kelurahan_opt: data_desa_kelurahan,

            dense:true, 
            data:[],
            modal_hapus_keluarga:false,
            modal_hapus_keluarga_2:false,
            modal_hapus:false,
            list_anggota_keluarga:[],
            modul:'kk1',
            form: {
              id:'',
              KKref:'',
              id_dari_form:'',

              m_provinsi : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '',

              permohonan: '',  
              permohonan_lainnya: '',  

              nama: '',  
              nik: '',  
              no_kk: '',  

              agama:'',
              agama_lainnya:'',
              pekerjaan:'',
              pekerjaan_lainnya:'',
              pendidikan:'',
              pendidikan_lainnya:'',
            
              jenis_kelamin: '',  
              tempat_lahir: '',  
              tanggal_lahir: '', 
              status_hubungan_dl_keluarga:'', 
              

              alamat: '',  
              rt: '',  
              rw: '',  
              kode_pos: '',  

              provinsi: '',
              kabupaten: '',
              kecamatan: '',
              desa_kelurahan: '',

               
              file_lampiran_kecamatan: null, 
              file_lampiran_kabupaten: null, 

              // ADMIN 
              status : 0,
              keterangan : 0,
              
              keterangan_deskel:'',
              keterangan_kecamatan:'',
              keterangan_kabupaten  :'',

              status_deskel:0,
              status_kecamatan:0,
              status_kabupaten  :0,

              createdBy : '',
              createdAt : '',
              createdAt_deskel:'',
              createdAt_kecamatan:'',
              createdAt_kabupaten  :'',

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',
              
              // ADMIN 

 
              file              : null, 
              fileThumb         : null, 
              file_lampiran     :null,
              file_lampiranOld  : null              
              

            },

            fileOld:'',
            fileOldThumb : '',

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayah_alamat : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },




            



            anggota_keluarga: {
                // no_kk :'', 
                nik  :'',
                nama  :'',

                jenis_kelamin   :'',
                tempat_lahir    :'',
                tanggal_lahir   :'',
                status_hubungan_dl_keluarga   :'', 

                agama:'',
                agama_lainnya:'',
                pekerjaan:'',
                pekerjaan_lainnya:'',
                pendidikan:'',
                pendidikan_lainnya:'',                

                KKref:'',
              },



        }
    },
    methods: { 
      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;
        });
      },

      clear_data(){
      this.form.id                              = '' 
      this.form.KKref                           = '' 
      this.form.id_dari_form                    = '' 
      this.form.m_provinsi                      = '74'  
      this.form.m_kabupaten                     = '7405' 
      this.form.m_kecamatan                     = '' 
      this.form.m_desa_kelurahan                = '' 
      this.form.permohonan                      = ''   
      this.form.permohonan_lainnya              = ''   
      this.form.nama                            = ''   
      this.form.nik                             = ''   
      this.form.no_kk                           = ''   
      this.form.agama                           = ''
      this.form.agama_lainnya                   = ''
      this.form.pekerjaan                       = ''
      this.form.pekerjaan_lainnya               = ''
      this.form.pendidikan                      = ''
      this.form.pendidikan_lainnya              = ''
      this.form.jenis_kelamin                   = ''   
      this.form.tempat_lahir                    = ''   
      this.form.tanggal_lahir                   = ''  
      this.form.status_hubungan_dl_keluarga     = '' 
      this.form.alamat                          = ''   
      this.form.rt                              = ''   
      this.form.rw                              = ''   
      this.form.kode_pos                        = ''   
      this.form.provinsi                        = '' 
      this.form.kabupaten                       = '' 
      this.form.kecamatan                       = ''
      this.form.desa_kelurahan                  = ''
      this.form.file_lampiran_kecamatan         = null
      this.form.file_lampiran_kabupaten         = null
      this.form.status                          = 0
      this.form.keterangan                      = 0
      this.form.keterangan_deskel               = ''
      this.form.keterangan_kecamatan            = ''
      this.form.keterangan_kabupaten            = ''
      this.form.status_deskel                   = 0
      this.form.status_kecamatan                = 0
      this.form.status_kabupaten                = 0
      this.form.createdBy                       = ''
      this.form.createdAt                       = ''
      this.form.createdAt_deskel                = ''
      this.form.createdAt_kecamatan             = ''
      this.form.createdAt_kabupaten             = ''
      this.form.file_terbitan                   = null
      this.form.emailPemohon                    = ''
      this.form.email_file                      = null
      this.form.email_fileOld                   = ''
      this.form.email_from                      = ''
      this.form.email_to                        = ''
      this.form.email_subject                   = ''
      this.form.email_html                      = ''
      this.form.file                            = null
      this.form.fileThumb                       = null
      this.form.file_lampiran                   = null
      this.form.file_lampiranOld                = null                      

      this.wilayah                              = {}                      
      this.wilayah_alamat                       = {}                      
      this.list_anggota_keluarga = [] 

      },

      addData:function(){
          this.$store.state.modal_loading = true;

          var formData = new FormData();
          formData.append("data", JSON.stringify(this.form));
          formData.append("biodata", JSON.stringify(this.list_anggota_keluarga));

          formData.append("file",           this.form.file);
          formData.append("file_lampiran",  this.form.file_lampiran);
            fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "addData", {
                method: "POST",
                headers: {
                    // "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => { 
                this.$store.state.modal_loading = false;
                this.$store.commit('notif_berhasil')
                this.getView();
            });
      },

      editData:function(){ 
        // console.log(JSON.stringify(this.form));
          this.$store.state.modal_loading = true;
          var formData = new FormData();
          formData.append("data", JSON.stringify(this.form));
          formData.append("file",           this.form.file);
          formData.append("file_lampiran",  this.form.file_lampiran);
          // formData.append("biodata", JSON.stringify(this.list_anggota_keluarga));

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "editData", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => {
              // console.log(res_data); 
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getView();
          });
      },
      
      EditAnggotaKeluarga:function(){  
          this.$store.state.modal_loading = true;
          var a = this.form.KKref  
          this.anggota_keluarga.KKref = a

          var formData = new FormData(); 
          formData.append("biodata", JSON.stringify(this.anggota_keluarga));

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "editData_AK", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => { 

              this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              var arr = this.list_anggota_keluarga; 
              arr.push(this.anggota_keluarga);
              
              this.anggota_keluarga = {
                no_kk :'', 
                nik  :'',
                nama  :'',
              }

              this.getView();
          });
      },
      
      removeData(data){
        this.$store.state.modal_loading = true;
        this.form.id = data.KK1.id;
        this.form.KKref = data.KK1.KKref;

        fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                KKref : this.form.KKref,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.$store.state.modal_loading = false;
            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        });         
      },


      selectData_keluarga(data, index){
        this.form.id = data._id
        
        this.index_ke = index
        console.log("ini index ke = "+ index);
        console.log("select = " + this.form.id);
      },     
      
      hapus_keluarga : function (data){ 
        this.$store.state.modal_loading = true;
        console.log("hapus_keluarga" + this.form.id); 
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "hapus_keluarga", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.$store.state.modal_loading = false;
            this.$store.commit('notif_berhasil_menghapus'); 
            this.list_anggota_keluarga.splice(this.index_ke, 1); 
            this.getView();
        });
      },

      delete_keluarga : function (index){ 
        console.log(index); 
        this.list_anggota_keluarga.splice(index, 1);  
      },
      
      selectData(data){
        console.log(data); 

         
        this.form.id = data.KK1.id

        this.form.KKref         = data.KK1.KKref
        this.form.id_dari_form  = data.KK1.id_dari_form

        this.form.m_provinsi           = data.KK1.m_provinsi
        this.form.m_kabupaten          = data.KK1.m_kabupaten
        this.form.m_kecamatan          = data.KK1.m_kecamatan
        this.form.m_desa_kelurahan     = data.KK1.m_desa_kelurahan
        this.form.permohonan           = data.KK1.permohonan
        this.form.permohonan_lainnya   = data.KK1.keterangan_lainnya
        this.form.nama                 = data.KK1.nama
        this.form.nik                  = data.KK1.nik
        this.form.no_kk                = data.KK1.no_kk
        this.form.alamat               = data.KK1.alamat
        this.form.rt                   = data.KK1.rt
        this.form.rw                   = data.KK1.rw
        this.form.kode_pos             = data.KK1.kode_pos
        this.form.provinsi             = data.KK1.provinsi
        this.form.kabupaten            = data.KK1.kabupaten
        this.form.kecamatan            = data.KK1.kecamatan
        this.form.desa_kelurahan       = data.KK1.desa_kelurahan

        this.form.agama                = data.KK1.agama
        this.form.agama_lainnya        = data.KK1.agama_lainnya
        this.form.pekerjaan            = data.KK1.pekerjaan
        this.form.pekerjaan_lainnya    = data.KK1.pekerjaan_lainnya
        this.form.pendidikan           = data.KK1.pendidikan
        this.form.pendidikan_lainnya   = data.KK1.pendidikan_lainnya        


        this.form.jenis_kelamin                   = data.KK1.jenis_kelamin
        this.form.tempat_lahir                    = data.KK1.tempat_lahir
        this.form.tanggal_lahir                   = data.KK1.tanggal_lahir
        this.form.status_hubungan_dl_keluarga     = data.KK1.status_hubungan_dl_keluarga


        this.$store.state.form.list_anggota_keluarga = data.databio;  

        this.list_anggota_keluarga = data.databio;  

        this.form.status_kecamatan = data.KK1.status_kecamatan
        this.form.status_kabupaten = data.KK1.status_kabupaten

        this.form.keterangan = data.KK1.keterangan
        this.form.keterangan_deskel = data.KK1.keterangan_deskel
        this.form.keterangan_kecamatan = data.KK1.keterangan_kecamatan
        this.form.keterangan_kabupaten = data.KK1.keterangan_kabupaten

        this.form.emailPemohon          = data.KK1.emailPemohon;
        this.form.email_fileOld         = data.KK1.email_file;
        this.form.email_from            = this.form.email_from;
        this.form.email_to              = this.form.emailPemohon;
        this.form.email_subject         = data.KK1.email_subject;

        this.form.file                  = data.KK1.file
        this.form.fileThumb             = data.KK1.fileThumb
        this.form.file_lampiran         = data.KK1.file_lampiran
        this.form.file_lampiranOld      = data.KK1.file_lampiranOld

        this.form.createdBy             = data.KK1.createdBy
        this.form.createdAt             = data.KK1.createdAt
        this.form.createdAt_deskel      = data.KK1.createdAt_deskel
        this.form.createdAt_kecamatan   = data.KK1.createdAt_kecamatan
        this.form.createdAt_kabupaten   = data.KK1.createdAt_kabupaten

        if (data.KK1.email_html == undefined || data.KK1.email_html == null || data.KK1.email_html == '') {
          this.form.email_html          = ''
        } else {
          this.form.email_html          = data.KK1.email_html; 
        }

        this.wilayah = {
          uraian_provinsi : data.m_provinsi.uraian,
          kd_provinsi : data.m_provinsi.kd_provinsi,
          uraian_kabupaten : data.m_kabupaten.uraian,
          kd_kabupaten : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan : data.m_kecamatan.uraian,
          kd_kecamatan : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
        };         
        this.wilayah_alamat = {
          uraian_provinsi : data.alamat_provinsi.uraian,
          kd_provinsi : data.alamat_provinsi.kd_provinsi,
          uraian_kabupaten : data.alamat_kabupaten.uraian,
          kd_kabupaten : data.alamat_kabupaten.kd_kabupaten,
          uraian_kecamatan : data.alamat_kecamatan.uraian,
          kd_kecamatan : data.alamat_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.alamat_desa_kelurahan.uraian,
          kd_desa_kelurahan : data.alamat_desa_kelurahan.kd_desa_kelurahan,
        };         

      },
      
      addAnggotaKeluarga: function(){
        // this.$store.commit('addanggota_keluarga');
        var arr = this.list_anggota_keluarga; 
        arr.push(this.anggota_keluarga);
        
        this.anggota_keluarga = {
          no_kk :'', 
          nik  :'',
          
          agama : '',
          agama_lainnya : '',
          pekerjaan : '',
          pekerjaan_lainnya : '',
          pendidikan : '',
          pendidikan_lainnya : '',          
        }

      },

      // ============================= KECAMATAN =============================
        getViewKecamatan : function(){
          // this.$store.commit("shoWLoading");
    // console.log(this.$store.state.lcProfile.provinsi);
    // console.log(this.$store.state.lcProfile.kabupaten);
    // console.log(this.$store.state.lcProfile.kecamatan);
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "viewKecamatan", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kecamatan  : this.form.status_kecamatan,
                  pl_provinsi       :this.$store.state.lcProfile.provinsi,
                  pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                  pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
              })
            })
              .then(res => res.json())
              .then(res_data => { 
                  this.list_data_kecamatan = res_data.data;
                  this.page_last = res_data.jmlData; 
                  // console.log("INI KECAMATAN")
                  console.log(res_data);
          });
        },


        editDataKecamatan : function(status){
          this.$store.state.modal_loading = true;
          // console.log(status)
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "editDataKecamatan", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kecamatan : this.form.keterangan_kecamatan,
                createdAt_kecamatan : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getViewKecamatan();
          });
        },

      // ============================= KECAMATAN =============================

      // ============================= KABUPATEN =============================
        getViewKabupaten : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "viewKabupaten", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kabupaten : this.form.status_kabupaten
              })
            })
              .then(res => res.json())
              .then(res_data => {
                // console.log("TAAAAAAAAAAIIIIIIII")
                  this.list_data_kabupaten = res_data.data;
                  this.page_last = res_data.jmlData;
                  // this.$store.commit("hideLoading");
                  console.log(res_data);
          });
        }, 
        editDataKabupaten : function(status){
          this.$store.state.modal_loading = true;
          console.log("SA DI CLICK")
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "editDataKabupaten", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kabupaten : this.form.keterangan_kabupaten,
                createdAt_kabupaten : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getViewKabupaten();
          });
        }, 

        terbit_file_Kabupaten : function(){
          this.$store.state.modal_loading = true;
          console.log(this.form.email_fileOld);
          var formData = new FormData();
          formData.append("id", this.form.id);
          formData.append("email_file", this.form.email_file); 
          formData.append("email_fileOld", this.form.email_fileOld); 
          formData.append("email_from", this.form.email_from)
          formData.append("email_to", this.form.email_to)
          formData.append("email_subject", this.form.email_subject) 
          formData.append("email_html", this.form.email_html)
          
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_BARU + "file_terbitan_Kabupaten", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData,
          }).then(res_data => { 
              this.wa_notif()
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_terbit');
              this.getView();
          });
        },

        async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Permohonan Kartu Keluarga (KK) Baru'
          }))
          console.log(data);
        },
      // ============================= KABUPATEN =============================

      bukaTab(linknya){
        window.open(linknya);
      },

    // ====================================== filter autocomplete  
      renderChildProv(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },
      renderChildKab(data) {
          return `
          <span><b>${data.kd_kabupaten}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKec(data) {
          return `
          <span><b>${data.kd_kecamatan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChild_des_kel(data) {
          return `
          <span><b>${data.kd_desa_kelurahan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    

      get_auto(data){
        console.log(data.kd_provinsi);  
        this.form.m_provinsi = data.m_provinsi   
      },        
      get_auto_kab(data){  
        this.form.m_kabupaten = data.m_kabupaten  
        console.log(data.kd_kabupaten); 
      },        
      get_auto_kec(data){  
        this.form.m_kecamatan = data.m_kecamatan  
        console.log(data.kd_kecamatan); 
      },        
      get_auto_des_kel(data){  
        this.form.m_desa_kelurahan = data.m_desa_kelurahan  
        console.log(data.kd_desa_kelurahan); 
      }, 

      // ==== daerah ================ 
        get_prov(data){
          console.log(data.kd_provinsi); 
          this.form.provinsi = data.m_provinsi   
        },        
        get_kab(data){ 
          this.form.kabupaten = data.m_kabupaten  
          console.log(data.kd_kabupaten); 
        },        
        get_kec(data){ 
          this.form.kecamatan = data.m_kecamatan  
          console.log(data.kd_kecamatan); 
        },        
        get_des_kel(data){ 
          this.form.desa_kelurahan = data.m_desa_kelurahan  
          console.log(data.kd_desa_kelurahan); 
        },        
      // ==== daerah ================  
    // ====================================== filter autocomplete       

    // ====================================== LEVEL USER 
      CariData(){
        
        // console.log(this.$store.state.lcProfile.kelas)

        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
          }else{
            this.getView();
          } 
      },
    // ====================================== LEVEL USER
    cekButton_status_kecamatan: function(data){  
      var a = data.KK1.status 
      var status_kab = data.KK1.status_kabupaten  
      if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
        if (status_kab == 1) {
          return true
        }
        return false
      }else{
        if (a == 1) {
          return true
        }else{
          return false
        }
      }  
    },

    check_user(){
      console.log(this.$store.state.lcProfile.kelas);

      if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
        // console.log('ini vertikal');
        return true
        
      } else {
        return false 
        
      }

    },
      
 

    },
    mounted(){
      this.check_user()
      // this.$store.state.form.list_anggota_keluarga = [];
      this.CariData();
      this.list_anggota_keluarga = [];
      this.MASTER_MENU.agama()
      this.MASTER_MENU.pekerjaan()
      this.MASTER_MENU.pendidikan()
      this.MASTER_MENU.shdk()

      // this.$store.state.lcProfile.kelas
      // console.log(this.$store.state.lcProfile.id); 

      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from 

    }
}
